import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Menu, Dropdown } from 'antd';
import { apiHolder as api, apis } from 'api';
import TimeIcon from '@web-common/components/UI/Icons/svgs/TimeSvg';
import AdvancedIcon from '@web-common/components/UI/Icons/svgs/AdvanceSearchSvg';
import './index.scss';
import { useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const SEARCH_TYPES = {
    all: { key: 'all', name: '', exclude: true },
    title: { key: 'title', name: getIn18Text('ZHUTI') },
    sender: { key: 'sender', name: getIn18Text('FAJIANREN') },
    receiver: { key: 'receiver', name: getIn18Text('SHOUJIANREN') },
    attachment: { key: 'attachment', name: getIn18Text('FUJIANMINGCHENG') },
};
const SEARCH_TYPES_OPTIONS = Object.keys(SEARCH_TYPES)
    .map(key => SEARCH_TYPES[key])
    .filter(v => !v.exclude);
const BaseSearchBox = ({ children, visible, searchWord, setAdvancedSearchVisible, setVisible, setSearchType, setInputValue, onSearchChange, searchType = SEARCH_TYPES.all.key, }) => {
    const [contentVisible, setContentVisible] = useState(false);
    const [associateVisible, setAssociateVisible] = useState(false);
    const [recordList, setRecordList] = useState([]);
    useEffect(() => {
        if (visible) {
            if (searchWord) {
                setContentVisible(true);
                setAssociateVisible(false);
                setRecordList([]);
            }
            else {
                mailApi.doGetMailSearchRecords(10).then(res => {
                    if (visible) {
                        if (res.length > 0) {
                            setContentVisible(false);
                            setTimeout(() => {
                                setAssociateVisible(true);
                                setRecordList(res);
                            }, 30);
                        }
                        else {
                            setContentVisible(false);
                            setAssociateVisible(false);
                            setRecordList([]);
                        }
                    }
                });
            }
        }
        else {
            setContentVisible(false);
            setAssociateVisible(false);
            setRecordList([]);
        }
    }, [visible, searchWord]);
    useEffect(() => {
        if (recordList.length === 0) {
            setAssociateVisible(false);
        }
    }, [recordList]);
    const onAdvancedClick = useCallback(() => {
        trackApi.track('pcMail_click_advancedSearch');
        setVisible(false);
        setAdvancedSearchVisible(true);
    }, []);
    const onItemSearchClick = useCallback((item) => {
        setSearchType(item.key);
        setVisible(false);
        onSearchChange(searchWord);
    }, [searchWord]);
    const onItemAllClick = useCallback(() => {
        setSearchType(SEARCH_TYPES.all.key);
        setVisible(false);
        onSearchChange(searchWord);
    }, [searchWord]);
    const onAssociateItemClick = useCallback((item) => {
        setInputValue(item.content);
        setSearchType(item.type);
        setVisible(false);
    }, []);
    const onAssociateDelClick = useCallback((item, index = 0) => {
        let payload = [];
        let delList = [];
        if (item) {
            payload = [...recordList.slice(0, index), ...recordList.slice(index + 1)];
            delList = [item.id];
        }
        else {
            delList = recordList.map(item => item.id);
        }
        setRecordList(payload);
        mailApi.doDeleteMailSearchRecord(delList).then();
    }, [recordList, setRecordList]);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const ContentMenu = useMemo(() => (React.createElement(Menu, { defaultSelectedKeys: [SEARCH_TYPES.all.key], selectedKeys: [searchType], className: "base-search-context-menu" },
        React.createElement(Menu.Item, { key: SEARCH_TYPES.all.key, className: "search-all-item", onClick: () => onItemAllClick() },
            React.createElement("span", null, getIn18Text('SOUSUOQUANBUJIE')),
            React.createElement("span", { className: "search-all-enter" }, "Enter")),
        isCorpMail
            ? ''
            : SEARCH_TYPES_OPTIONS.map(it => (React.createElement(Menu.Item, { key: it.key, onClick: () => onItemSearchClick(it) },
                it.name,
                getIn18Text('BAOHAN1'),
                React.createElement("span", { className: "highlight" }, searchWord)))),
        React.createElement(Menu.Divider, null),
        React.createElement(Menu.Item, { key: "advancedSearch", className: "advanced-search-item", onClick: onAdvancedClick },
            React.createElement(AdvancedIcon, { className: "advanced-search-icon" }),
            getIn18Text('GAOJISOUSUO')))), [searchWord, searchType]);
    const AssociateMenu = useMemo(() => (React.createElement(Menu, { className: "base-search-associate-menu" },
        React.createElement(Menu.Item, { key: "recordTitle", className: "associate-title" },
            React.createElement("div", { className: "associate-item-title" },
                React.createElement("span", null, getIn18Text('LISHISOUSUO')),
                React.createElement("span", { className: "associate-item-clear", onClick: () => onAssociateDelClick() }, getIn18Text('QINGKONG')))),
        recordList.map((it, index) => (React.createElement(Menu.Item, { key: it.id, className: "associate-item", onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                onAssociateItemClick(it);
            } },
            React.createElement(TimeIcon, { className: "associate-item-icon" }),
            React.createElement("span", { className: "associate-item-content", title: it.content }, it.content),
            React.createElement("span", { className: "associate-item-type" }, SEARCH_TYPES[it.type].name),
            React.createElement("span", { className: "associate-item-delete", onMouseDown: e => {
                    e.stopPropagation();
                    e.preventDefault();
                    onAssociateDelClick(it, index);
                } })))),
        React.createElement(Menu.Divider, null),
        React.createElement(Menu.Item, { key: "advancedSearch", className: "associate-item", onClick: onAdvancedClick },
            React.createElement(AdvancedIcon, { className: "advanced-search-icon" }),
            getIn18Text('GAOJISOUSUO')))), [recordList]);
    const DropdownOverlay = useMemo(() => {
        if (visible) {
            if (contentVisible) {
                return ContentMenu;
            }
            if (associateVisible) {
                return AssociateMenu;
            }
        }
        return React.createElement(React.Fragment, null);
    }, [visible, contentVisible, associateVisible, recordList]);
    return (React.createElement(Dropdown, { overlay: DropdownOverlay, visible: visible && (contentVisible || associateVisible), trigger: ['click'] }, children));
};
export default BaseSearchBox;
